{
  "version": 1,
  "asset_id": "cd35df11-aecf-4fd1-9465-1902e6d65645",
  "project_id": "81864b6f-53ca-42c2-811b-21ffcbfd0515",
  "url": "/__l5e/assets-v1/cd35df11-aecf-4fd1-9465-1902e6d65645/maison-pacini.webp",
  "r2_key": "a/v1/81864b6f-53ca-42c2-811b-21ffcbfd0515/cd35df11-aecf-4fd1-9465-1902e6d65645/maison-pacini.webp",
  "original_filename": "maison-pacini.webp",
  "size": 175942,
  "content_type": "image/webp",
  "created_at": "2026-07-13T07:04:13Z"
}
